module.exports = __webpack_public_path__ + "static/img/13.9c4668d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/8/zh/13.png
// module id = VH8E
// module chunks = 0